import {
  type NavigationFailure,
  type RouteLocationRaw,
  useRoute,
  useRouter,
} from 'vue-router';

export function useRouterBack() {
  const router = useRouter();
  const route = useRoute();

  return (fallbackTo: RouteLocationRaw = '/') => {
    if (!router.options.history.state.back) {
      return router.replace(fallbackTo);
    }

    return new Promise<NavigationFailure | void | undefined>(
      (resolve, reject) => {
        // Ensure `back` complete
        const timer = setTimeout(() => {
          unbind();

          if (route.fullPath !== router.resolve(fallbackTo).fullPath) {
            router.replace(fallbackTo).then(resolve, reject);
          } else {
            resolve();
          }
        }, 1000);

        const unbind = router.beforeEach(() => {
          unbind();

          clearTimeout(timer);

          resolve();
        });

        router.back();
      },
    );
  };
}
